/**
 * Shared className for the Figma-spec "secondary pill" button — a white
 * h-11 button with a soft gray border and a subtle hover lift. Used for
 * the "View completed" and "Manage AI Agents" buttons in the action
 * center header (and any new secondary header actions).
 *
 * Extracted to avoid silent drift between the two long classNames.
 */
export const secondaryPillButtonClass =
  'inline-flex items-center gap-1.5 h-11 bg-white border border-neutral-300 rounded-lg px-3 text-sm font-medium text-neutral-800 tracking-[-0.2px] whitespace-nowrap transition-all hover:bg-neutral-100 hover:text-neutral-900 hover:shadow-sm hover:border-neutral-400'
